// removed by extract-text-webpack-plugin
module.exports = {"container":"beNDk63iZt5z1iiXeAASv"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/DocumentInformation/UpdateForm/Save/styles.css
// module id = 3273
// module chunks = 0